import React from 'react';
import { SmartLink } from '../SmartLink';
type CtaBandProps = {
  headline: string;
  subheadline: string;
  primary: {
    label: string;
    href: string;
  };
  secondary: {
    label: string;
    href: string;
  };
};
export function CtaBand({
  headline,
  subheadline,
  primary,
  secondary
}: CtaBandProps) {
  return <section data-nav-theme="dark" className="footer-gradient w-full py-20" aria-labelledby="company-cta-heading" data-id="element-314" data-mp="33b3miritncrj">
      <div className="mx-auto max-w-shell px-6 text-center" data-id="element-315" data-mp="388lx0mchm01n">
        <h2 id="company-cta-heading" className="display text-[32px] font-semibold text-white sm:text-[44px]" data-id="element-316" data-mp="3cb8rkv0jlz2j">
          {headline}
        </h2>
        <p className="mx-auto mt-5 max-w-[500px] text-[16px] leading-[1.55] text-white/70" data-id="element-317" data-mp="3h30d2r4udelt">{subheadline}</p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-318" data-mp="3lzqrla100254">
          <SmartLink href={primary.href} className="inline-flex h-12 w-full items-center justify-center rounded-[7px] bg-brand px-6 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-hover sm:w-auto" data-id="element-319" data-mp="3r1g1gmchi9rm">
            {primary.label}
          </SmartLink>
          <SmartLink href={secondary.href} className="inline-flex h-12 w-full items-center justify-center rounded-[7px] border border-white/30 px-6 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:border-white/60 sm:w-auto" data-id="element-320" data-mp="3tquuegptcxa">
            {secondary.label}
          </SmartLink>
        </div>
      </div>
    </section>;
}